import validator from "validator";
import { FormFieldTypes } from "../../../data/formFieldType";

export const keyPositionRequestFormData = {
  // Accordion 1 — Account Information
  accountInfo: {
    name: "AccountInformationForm",
    initialState: {
      companyName: "",
      companyRegNumber: "",
      membershipType: "",
      joinedDate: "",
      subscriptionStartDate: "",
      subscriptionEndDate: "",
    },
    formFields: [
      {
        id: "companyName",
        lable: "Registered Company Name (as per ACRA or Registry records)",
        Field_Name: "Company Name",
        fieldType: FormFieldTypes.INPUT,
        dataField: "companyName",
        fieldSetting: {
          placeholder: "Enter Company Name",
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
        },
      },
      {
        id: "companyRegNumber",
        lable: "UEN / Company Registration Number",
        Field_Name: "Company Registration Number",
        fieldType: FormFieldTypes.INPUT,
        dataField: "companyRegNumber",
        fieldSetting: {
          placeholder: "Enter Company Registration Number",
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
        },
      },
      {
        id: "membershipType",
        lable: "Membership Type",
        Field_Name: "Membership Type",
        fieldType: FormFieldTypes.INPUT,
        dataField: "membershipType",
        fieldSetting: {
          placeholder: "Enter Membership Type",
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
        },
      },
      {
        id: "joinedDate",
        lable: "Joined Date",
        Field_Name: "Joined Date",
        fieldType: FormFieldTypes.DATEPICKER,
        dataField: "joinedDate",
        fieldSetting: {
          placeholder: "Select Joined Date",
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
        },
      },
      {
        id: "subscriptionStartDate",
        lable: "Subscription Start Date",
        Field_Name: "Subscription Start Date",
        fieldType: FormFieldTypes.DATEPICKER,
        dataField: "subscriptionStartDate",
        fieldSetting: {
          placeholder: "Select Start Date",
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
        },
      },
      {
        id: "subscriptionEndDate",
        lable: "Subscription End Date",
        Field_Name: "Subscription End Date",
        fieldType: FormFieldTypes.DATEPICKER,
        dataField: "subscriptionEndDate",
        fieldSetting: {
          placeholder: "Select End Date",
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
        },
      },
    ],
    formSetting: { isViewOnly: true },
  },

  // Accordion 2 — Change Key Position Information
  positionInfo: {
    name: "ChangeKeyPositionInformationForm",
    initialState: {
      currentFirstName: null,
      salutationId:null,
      currentLastName: null,
      currentDesignation: null,
      currentEmail: null,
      currentJobLevel: null,
      currentJobFunction: null,
      currentMobile: null,
      currentTelephone: null,
      newFirstName: null,
      newSalutationId: null,
      newLastName: null,
      newDesignation: null,
      newEmail: null,
      newJobLevel: null,
      newJobFunction: null,
      newMobile: null,
      newTelephone: null,
      approvalDate:new Date(),
      approvalBy: null,
    },
    formFields: [
      {
        id: "currentTitle",
        lable: "Current Position: Official Management Representative",
        Field_Name: "formSubtitle",
        fieldType: FormFieldTypes.MAINFORMTITLE,
        dataField: "currentTitle",
        fieldSetting: {
          formTitle: "",
          isDisable: true,
        },
        style: {
          containerCss: " custom-text-green",
        },
      },

      {
        id: "currentFirstName",
        lable: "First Name or Given Name",
        Field_Name: "First Name or Given Name",
        // fieldType: FormFieldTypes.INPUT,
        // dataField: "currentFirstName",
        fieldType: FormFieldTypes.INPUTGROUPSELECT,
        dataField: ["salutationId", "currentFirstName"],
        fieldSetting: {
          placeholder: "Enter First Name",
          isDisable: true,
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3 no-star ",
        },
      },
      {
        id: "currentLastName",
        lable: "Last Name or Surname",
        Field_Name: "Last Name or Surname",
        fieldType: FormFieldTypes.INPUT,
        dataField: "currentLastName",
        fieldSetting: {
          placeholder: "Enter Last Name",
          isDisable: true,
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
        },
      },
      {
        id: "currentDesignation",
        lable: "Designation",
        Field_Name: "Designation",
        fieldType: FormFieldTypes.INPUT,
        dataField: "currentDesignation",
        fieldSetting: {
          placeholder: "Enter Designation",
          isDisable: true,
        },

        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
        },
      },
      {
        id: "currentEmail",
        lable: "Email Address",
        Field_Name: "Email Address",
        fieldType: FormFieldTypes.INPUT,
        dataField: "currentEmail",
        fieldSetting: {
          placeholder: "Enter Email Address",
          isDisable: true,
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
        },
      },
      {
        id: "currentJobLevel",
        lable: "Job Level",
        Field_Name: "Job Level",
        fieldType: FormFieldTypes.SELECT,
        dataField: "currentJobLevel",
        fieldSetting: {
          placeholder: "Enter Job Level",
          isDisable: true,
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
        },
      },
      {
        id: "currentJobFunction",
        lable: "Job Function",
        Field_Name: "Job Function",
        fieldType: FormFieldTypes.SELECT,
        dataField: "currentJobFunction",
        fieldSetting: {
          placeholder: "Enter Job Function",
          isDisable: true,
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
        },
      },
      {
        id: "currentMobile",
        lable: "Mobile Number",
        Field_Name: "Mobile Number",
        fieldType: FormFieldTypes.INPUTGROUPSELECT,
        dataField: ["mobileNumberCountryId", "currentMobile"],
        fieldSetting: {
          placeholder: "",
          isDisable: true,
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3 no-star",
        },
      },
      {
        id: "currentTelephone",
        lable: "Telephone DID / Contact Number",
        Field_Name: "Contact Number",
        fieldType: FormFieldTypes.INPUTGROUPSELECT,
        dataField: ["contactNumberCountryId", "currentTelephone"],
        fieldSetting: {
          placeholder: "",
          isDisable: true,
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3 no-star",
        },
      },
      {
        id: "newTitle",
        lable: "New",
        Field_Name: "formSubtitle",
        fieldType: FormFieldTypes.MAINFORMTITLE,
        dataField: "newTitle",
        fieldSetting: {
          formTitle: "New",
        },
        style: {
          containerCss: "custom-text-green ",
        },
      },
      //  fieldType: FormFieldTypes.INPUTGROUPSELECT,
      //   dataField: ["newContactNumberCountryId", "newMobile"],
      {
        id: "newFirstName",
        lable: "First Name or Given Name",
        Field_Name: "First Name or Given Name",
        // fieldType: FormFieldTypes.INPUT,
        // dataField: "newFirstName",
        fieldType: FormFieldTypes.INPUTGROUPSELECT,
        dataField: ["newSalutationId", "newFirstName"],
        fieldSetting: {
          placeholder: "Enter First Name",
          isDisable: true,
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3 no-star",
        },
      },
      {
        id: "newLastName",
        lable: "Last Name or Surname",
        Field_Name: "Last Name or Surname",
        fieldType: FormFieldTypes.INPUT,
        dataField: "newLastName",
        fieldSetting: {
          placeholder: "Enter Last Name",
          isDisable: true,
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3 ",
        },
      },
      {
        id: "newDesignation",
        lable: "Designation",
        Field_Name: "Designation",
        fieldType: FormFieldTypes.INPUT,
        dataField: "newDesignation",
        fieldSetting: {
          placeholder: "Enter Designation",
          isDisable: true,
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3 ",
        },
      },
      {
        id: "newEmail",
        lable: "Email Address",
        Field_Name: "Email Address",
        fieldType: FormFieldTypes.INPUT,
        dataField: "newEmail",
        fieldSetting: {
          placeholder: "Enter Email Address",
          isDisable: true,
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3 ",
        },
      },
      {
        id: "newJobLevel",
        lable: "Job Level",
        Field_Name: "Job Level",
        fieldType: FormFieldTypes.SELECT,
        dataField: "newJobLevel",
        fieldSetting: {
          placeholder: "Enter Job Level",
          isDisable: true,
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3 ",
        },
      },
      {
        id: "newJobFunction",
        lable: "Job Function",
        Field_Name: "Job Function",
        fieldType: FormFieldTypes.SELECT,
        dataField: "newJobFunction",
        fieldSetting: {
          placeholder: "Enter Job Function",
          isDisable: true,
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3 ",
        },
      },
      {
        id: "newMobile",
        lable: "Mobile Number",
        Field_Name: "Mobile Number",
        fieldType: FormFieldTypes.INPUTGROUPSELECT,
        dataField: ["newMobileNumberCountryId", "newMobile"],
        fieldSetting: {
          placeholder: "",
          isDisable: true,
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3 no-star",
        },
      },
      {
        id: "newTelephone",
        lable: "Telephone DID / Contact Number",
        Field_Name: "Contact Number",
        fieldType: FormFieldTypes.INPUTGROUPSELECT,
        dataField: ["newContactNumberCountryId", "newTelephone"],
        fieldSetting: {
          placeholder: "",
          isDisable: true,
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3 no-star",
        },
      },
      // SEPARATOR FIELD
      {
        id: "",
        lable: "",
        Field_Name: "",
        fieldType: FormFieldTypes.SEPARATOR,
        dataField: "",
        fieldSetting: {
          placeholder: "",
          isDisable: true,
        },
        style: {
          containerCss: "col-lg-12 col-xl-12 col-md-12 col-sm-12 mb-3 no-star",
        },
      },
      {
        id: "approvalTitle",
        lable: "",
        Field_Name: "formTitle",
        fieldType: FormFieldTypes.MAINFORMTITLE,
        dataField: "approvalTitle",
        fieldSetting: {
          formTitle: "SGBC Approval",
          isDisable: true,
        },
        style: {
          containerCss: "comman-sub-title",
        },
      },
      {
        id: "approvalDate",
        lable: "Approval Date",
        Field_Name: "Approval Date",
        fieldType: FormFieldTypes.DATEPICKER,
        dataField: "approvalDate",
        fieldSetting: {
          placeholder: "Select Approval Date",
          //  isDisable: true,
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
        },
      },
      {
        id: "approvalBy",
        lable: "SGBC Staff",
        Field_Name: "SGBC Staff",
        fieldType: FormFieldTypes.INPUT,
        dataField: "approvalBy",
        fieldSetting: {
          isDisable: true,
        },
        style: {
          containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3 ",
        },
      },

    ],
    formSetting: { isViewOnly: false },
  },



};
